import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  CircularProgress,
  Typography,
  TextField,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
import VolumeItem from "../components/volume-item";
import HomeNavbar from "../components/home-nav-bar";

function Volumes() {
  const [volumes, setVolumes] = useState([]);
  const [filteredVolumes, setFilteredVolumes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    axios
      .get("https://api.wajls.com/client/v1/fetch_volumes.php?limit=*")
      .then((response) => {
        setVolumes(response.data);
        setFilteredVolumes(response.data);
        setLoading(false);
      })
      .catch((err) => {
        setError("Failed to load volumes data.");
        setLoading(false);
      });
  }, []);
  

  useEffect(() => {
    const query = searchQuery.toLowerCase();
    const filtered = volumes.filter((volume) => {
      return (
        volume.title?.toLowerCase().includes(query)
      );
    });
    setFilteredVolumes(filtered);
  }, [searchQuery, volumes]);

  return (
    <Box sx={{ mt: 2, backgroundColor: "grey.100", minHeight: "100vh"}}>
      <HomeNavbar/>
      <Box sx={{ p: 1, maxWidth: 'lg', margin: 'auto' }}>
        <TextField
            fullWidth
            placeholder="Search by title, author, or volume"
            variant="outlined"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            sx={{ mb: 3, backgroundColor: "white", borderRadius: 1 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
            }}
        />

        {loading ? (
          <Box display="flex" justifyContent="center" mt={5}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Typography color="error">{error}</Typography>
        ) : filteredVolumes.length === 0 ? (
          <Typography color="textSecondary">No volumes found.</Typography>
        ) : (
          <Box>
            {filteredVolumes.map((volume) => (
              <VolumeItem
                key={volume.id}
                title={volume.title}
                abstract_url={volume.abstract_url}
                price={volume.price}
              />
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default Volumes;
